import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { OrderItemProcessesComponent } from '@components/orders/manage-orders/order-item-processes/order-item-processes.component';
import { ListsDeleteComponent } from '@components/orders/saved-lists/lists-delete/lists-delete.component';
import { ListsExportComponent } from '@components/orders/saved-lists/lists-export/lists-export.component';
import { ManageSavedListsComponent } from '@components/orders/saved-lists/manage-saved-lists/manage-saved-lists.component';
import { filter, take } from 'rxjs/operators';

import { OrdersActions } from '../../../../@store/orders/orders.actions';
import { selectSingleListLoading } from '../../../../@store/orders/orders.selectors';
import { SavedListTableComponent } from '../saved-list-table/saved-list-table.component';

export type ExportType = 'csv' | 'pdf';

@Component({
  selector: 'ciwc-order-list-view',
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatProgressSpinnerModule,
    NgIf,
    MatIcon,
    MatDialogModule,
    ManageSavedListsComponent,
    SavedListTableComponent,
  ],
  standalone: true,
  templateUrl: './order-list-view.component.html',
  styleUrl: './order-list-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderListViewComponent implements OnInit {
  @ViewChild(OrderItemProcessesComponent) itemProcessesComponent!: OrderItemProcessesComponent;
  @ViewChild(ManageSavedListsComponent) manageSavedListsComponent!: ManageSavedListsComponent;
  protected listId: number | undefined = undefined;

  readonly loading$ = this.store.selectSignal(selectSingleListLoading);

  constructor(
    private store: Store,
    protected route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (params['id']) {
        this.listId = params['id'];
      }
    });
  }

  deleteList(): void {
    const listName = this.manageSavedListsComponent.form.get('listName')?.value;

    this.dialog.open(ListsDeleteComponent, {
      data: {
        listId: this.listId,
        listName: listName,
      },
    });
  }

  exportList(type: ExportType): void {
    const listName = this.manageSavedListsComponent.form.get('listName')?.value;

    this.dialog.open(ListsExportComponent, {
      data: {
        listId: this.listId,
        listName: listName,
        type,
      },
    });
  }

  onSaveList(event: { id: number | undefined; payload: any }) {
    if (event.id) {
      this.store.dispatch(OrdersActions.updateSingleList({ id: event.id, payload: event.payload }));
      this.store
        .select(selectSingleListLoading)
        .pipe(
          filter((loading) => !loading),
          take(1),
        )
        .subscribe(() => {
          this.router.navigate(['/orders', 'saved-lists']).then((success: boolean): void => {
            if (success) {
              console.log('Navigation successful after saving!');
            } else {
              console.warn('Navigation failed after saving!');
            }
          });
        });
    }
  }
}
